import React, { useRef } from "react";
import { Outlines, useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/plots/01-Pond.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }

  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube049.geometry}
        material={materials["00-Base2"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube053.geometry}
        material={materials["03-FountainWater"]}
        position={[0.126, 0.045, 0.089]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube054.geometry}
        material={materials["04-RocksGray"]}
        position={[0.583, 0.137, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube060.geometry}
        material={materials["02-BenchWood"]}
        position={[-0.449, 0.155, 0.243]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube073.geometry}
        material={materials["05-BerryRed"]}
        position={[-0.345, 0.264, -0.66]}
        rotation={[2.097, -0.151, -2.235]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube225.geometry}
        material={materials["00-Grass1"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder003.geometry}
        material={materials["01-TreeGreen2"]}
        position={[-0.609, 0.257, -0.209]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder008.geometry}
        material={materials["01-TreeGreen1"]}
        position={[0.639, 0.597, -0.778]}
        rotation={[0, 0.926, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder009.geometry}
        material={materials["01-TreeTrunk"]}
        position={[-0.744, 0.235, 0.004]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/01-Pond.glb");
